import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';
import { MOVEMENT_DIRECTION } from '../../../Preview/PreviewDisplayConstants';

const directionOptions = [
    { value: MOVEMENT_DIRECTION.INWARD, text: 'Inward' },
    { value: MOVEMENT_DIRECTION.OUTWARD, text: 'Outward' },
];

const VisualizerDirectionListItem = (props) => {
    const { movementDirection, updateVisualizerSettings } = props;
    const onDirectionChange = (value) => updateVisualizerSettings({ movementDirection: value });

    return (
        <ToggleButtonListItem
            text='Direction'
            value={movementDirection || MOVEMENT_DIRECTION.OUTWARD}
            onChange={onDirectionChange}
            options={directionOptions}
        />
    );
};

const mapStateToProps = (state) => {
    const { movementDirection } = state.createPreview.present.videoSettings.visualizer;
    return { movementDirection };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDirectionListItem);
